import React from 'react';
import { FormControlLabel, Switch, Box } from '@mui/material';

export default function MoeField({ value, onChange, disabled = false }) {
  return (
    <Box>
      <FormControlLabel
        control={
          <Switch
            checked={Boolean(value)}
            onChange={(e) => onChange(e.target.checked)}
            name='moe'
            disabled={disabled}
          />
        }
        label='MoE Model?'
      />
    </Box>
  );
}
